export const convertBytesToMegabytes = (bytes: number) => (bytes !== 0 ? bytes / 1024 / 1024 : 0);
